import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';

import { companyActions } from '../../../../redux/company/actions';
import { getExportingStatus, getLoadingStatus } from '../../../../redux/company/selectors';

export const ExportCompaniesButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const exporting = useSelector(getExportingStatus);
  const loading = useSelector(getLoadingStatus);

  return (
    <Button
      disabled={loading}
      loading={exporting}
      onClick={() => dispatch(companyActions.exportCompanies())}
      icon={<DownloadOutlined />}
    >
      {t('myCompanies.export')}
    </Button>
  );
};
